export const PageText = {
  _1: 'Highly validated',
  _2: 'Validation is the key for aircheckr. We are not only saying that aircheckr reaches high quality, we show it!'
};

export const Categories = {
  _1: {
    title: 'In-depth validation',
    subcategories: [
      {
        key: 0,
        subtitle: 'Statistical comparison with independent sources',
        text: 'aircheckr results are statistically compared with several independent measurement sources and other validated models on a regular basis. The validation of aircheckr is focused on results within Flanders (Belgium).'
      },
      {
        key: 1,
        subtitle: 'Two major models',
        text: 'aircheckr provides air quality information at different levels of detail: from your street up to an entire country. The models responsible for that are however not all the same. Two major models can be differentiated: Street level & City level (including areas of higher level administrations, ex: provinces).'
      }
    ]
  },
  _2: {
    title: 'Street level model',
    subcategories: [
      {
        key: 0,
        subtitle: 'Objective',
        text: 'To offer near real-time air quality data at a much higher spatial resolution than what is already available, with equivalent or higher temporal validation results.'
      },
      {
        key: 1,
        subtitle: 'Approach',
        text: 'Both temporal and spatial validations are performed for four different pollutants. The aircheckr results are statistically compared with several reference validation datasets: 1) the hourly RIO-IFDM high resolution model (credits to VITO & IRCELINE), 2) the measurements of some independent stations & 3) the results of a passive samplers’ measurements campaign.'
      },
      {
        key: 2,
        subtitle: 'Results',
        text: 'As the outcomes are too extensive to be elaborated here, one specific independent validation exercise performed by the Belgian Interregional Environment Agency (IRCEL – CELINE ; 2016) is highlighted. A time series of hourly measurements for 3 independent measuring stations in the region of Antwerp in the months of February, May, August and November 2016 is compared with the outcomes of aircheckr. The table below summaries the results. R<sup>2</sup> stands for the ‘coefficient of determination’ and goes up to 1. The better the model performs the closer it gets to 1. Generally, an R<sup>2</sup> of 0.65 is already considered as being good.'
      }
    ]
  },
  _3: {
    subcategories: [
      {
        key: 0,
        subtitle: 'Conclusion',
        text: 'The various validations completed for all 4 pollutants (NO<sub>2</sub>, O<sub>3</sub>, PM<sub>10</sub> and PM<sub>2.5</sub>) show the great added value of aircheckr over available models as a near real-time air quality model, especially alongside main roads. aircheckr is very accurate in modelling the temporal variations of the air quality for a specific location and is a scientifically sound estimation of the real-time Street level AQ data.'
      }
    ]
  },
  _4: {
    title: 'City level model',
    subcategories: [
      {
        key: 0,
        subtitle: 'Highly validated data sources as an input',
        text: 'The quality of the City level product is completely dependent on the quality of the input data. aircheckr only uses highly validated data sources as an input. In current version of the City level model the near real-time RIO data is used for Belgium. The RIO model is an interpolation technique (owned by IRCELINE) with a spatial resolution of 4 km<sup>2</sup> that has been intensively validated (e.g. in <a href="https://www.researchgate.net/publication/252915197_RIO_A_NOVEL_APPROACH_FOR_AIR_POLLUTION_MAPPING" target="_blank">this article</a>). For the rest of EU, data of <a href="https://atmosphere.copernicus.eu/" target="_blank">Copernicus Atmosphere Monitoring Service</a> are used.'
      }
    ]
  }
};

export const Quotes = [
  {
    key: 0,
    text: 'Real-time air quality data from aircheckr can empower many smart city services and businesses, positively impacting citizen life and work.',
    author: 'Davor Meersman, IMEC and Open & Agile Smart Cities'
  },
  {
    key: 1,
    text: 'Aircheckr is making clever use of data science to make solid, accurate, detailed and real-time air pollution predictions',
    author: 'Nele Verbiest, Python Predictions'
  }
];

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/highly-validated_page.js